import React from "react";
import ProgressRectangle from "./Rectangles/ProgressRectangle";
import NotCurrPageRec from "./Rectangles/NotCurrPageRec";
import { Container } from "./Styled";

const HeaderSetAccount = ({progress}: any) => {
    return(
        <Container>
            <table>
                <tbody>
                    <tr>
                        <td className="step-tr active" >
                            <div>Sign Up</div>
                            <ProgressRectangle progress={progress} />
                        </td>
                        <td className="step-tr">
                            <div>Upload File</div>
                            <NotCurrPageRec/>
                        </td>
                        <td className="step-tr">
                            <div>Complete Order</div>
                            <NotCurrPageRec/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </Container>
    );

};

export default HeaderSetAccount;
